module.exports = __webpack_public_path__ + "static/img/5-nei.d10d9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/5-nei.png
// module id = DhQl
// module chunks = 1